export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 60,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.form_label_content') || '含量',
    field: 'content',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => (cellValue ? `${cellValue}%` : ''),
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        max: 100,
        precision: 2,
        controls: false,
      },
    },
    className: 'content-cell',
  },
  {
    title: that.$l('INDEX.table_label_componentPositionName') || '成分位置',
    field: 'componentPositionCn',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_Chinese_Name') || '中文名称',
    field: 'optionName',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_English_Name') || '英文名称',
    field: 'optionNameEn',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
